export default "__VITE_ASSET__DHacdU$Z__"